import { render, staticRenderFns } from "./DetailClient.vue?vue&type=template&id=54c252ad"
import script from "./DetailClient.vue?vue&type=script&lang=js"
export * from "./DetailClient.vue?vue&type=script&lang=js"
import style0 from "./DetailClient.vue?vue&type=style&index=0&id=54c252ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports